import { StyleSheet, Dimensions } from 'react-native'
import { colorText } from '../../../../themeConstants'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: Dimensions.get('window').width,
        height: Dimensions.get('window').width,
        alignItems: 'center',
        justifyContent: 'center',
    },
    backgroundImage: {
        flex: 1,
        width: '100%',
        aspectRatio: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    questionContainer: {
        padding: 10,
        //margin: 10,
    },
    optionText: {
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        color: colorText,
        lineHeight: 24,
        marginBottom: 20,
        marginHorizontal: 0,
    },
    optionContainer: {
        padding: 10,
        marginHorizontal: 0,
        marginBottom: 15,
        borderColor: 'white',
        borderRadius: 10,
        borderWidth: 0.5,
    },
    options: {
        fontSize: 16,
        fontWeight: 'normal',
        textAlign: 'center',
        color: colorText,
        lineHeight: 20,
    },
    feedback: {
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center',
        color: colorText,
        marginHorizontal: 40,
    },
    feedbackText: {
        fontSize: 15,
        textAlign: 'center',
        color: colorText,
        lineHeight: 21,
        marginTop: 40,
        marginBottom: 20,
        marginHorizontal: 50,
    },
    buttomRestart: {
        padding: 10,
        margin: 10,
        borderColor: 'white',
        backgroundColor: 'blue',
        borderRadius: 4,
        borderWidth: 1.2,
    },
    textRestart: {
        fontSize: 16,
        textAlign: 'center',
        color: 'white',
    },
})
export default styles
